<template>
  <v-navigation-drawer
    app
    v-model="model"
    :mobile-breakpoint="$vuetify.breakpoint.thresholds.sm"
  >
    <v-list dense nav class="py-0">
      <v-list-item>
        <v-img
          aspect-ratio="2"
          contain
          rel="preload"
          :src="$store.getters['config/getOrganizationLogo']"
        ></v-img>
      </v-list-item>

      <v-divider class="mb-4"></v-divider>
      <NavItem
        v-for="item in navItems"
        :title="$t(item.title)"
        :icon="item.icon"
        :route="item.route"
        :key="item.route"
        :display_getter="item.display_getter"
      ></NavItem>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import NavItem from "../../portal/components/drawer/components/NavItem.vue";

export default {
  name: "Drawer",
  components: { NavItem },
  data() {
    return {
      model: this.$vuetify.breakpoint.mdAndUp,
      navItems: [
        {
          title: "nav.webshop",
          icon: "mdi-store",
          route: "webshop-no-login"
        }
      ]
    };
  },

  computed: {
    usingIntegrator() {
      return (
        this.$store.state.config.webshop_configuration.mode ===
        "enabled_for_integrator"
      );
    }
  },

  mounted() {
    if (!this.usingIntegrator) {
      this.navItems.unshift({
        title: "nav.home",
        icon: "mdi-home",
        route: "login"
      });
    }
  }
};
</script>

<style scoped>
.theme--dark.v-navigation-drawer {
  background-color: #272727;
}
</style>
